import './footerPolicy.scss';

import React, { FunctionComponent } from 'react';

import { FooterPaymentCards } from './FooterPaymentCards';

import progyLogo from '../../../images/LOGO_PROGY_BLANC.svg';
import { useTranslation } from 'react-i18next';
import { LocalizedLink } from '../../primitives';
import SiteLocaleSelectionPopupMenu from '../../siteLocale/SiteLocaleSelectionPopupMenu';

export const FooterPolicy: FunctionComponent = () => {
    const { t } = useTranslation('mainLayout');

    return (
        <div className='footer-policy'>
            <div className='row footer-intl'>
                <div className='col col-popup'>
                    <SiteLocaleSelectionPopupMenu direction='top' />
                </div>
                <div className='col'></div>
                <div className='col col-cards'>
                    <FooterPaymentCards />
                </div>
            </div>
            <div className='row footer-actions'>
                <div className='container'>
                    <div className='row'>
                        <ul className='nav-horizontal'>
                            <LocalizedLink
                                className='policy'
                                to='/return-policy/'
                            >
                                <span>{t('return-policy')}</span>
                            </LocalizedLink>
                            <LocalizedLink
                                className='policy'
                                to='/shipping-policy/'
                            >
                                <span>{t('shipping-policy')}</span>
                            </LocalizedLink>
                            <LocalizedLink
                                className='policy'
                                to='/privacy-policy/'
                            >
                                <span>{t('privacy-policy')}</span>
                            </LocalizedLink>
                        </ul>
                    </div>
                </div>
            </div>
            <FooterPaymentCards mobile />
            <div className='developed-by'>
                <a target='__blank' href='https://www.progymedia.com'>
                    {t('pages:developed-by')}
                    <img src={progyLogo} alt='Progymédia logo' />
                </a>
                {t('copyright', { year: new Date().getFullYear() })}
            </div>
        </div>
    );
};
